import { Typography } from '@ui/uikit/components/common/Typography';

import { usePredictionEntries } from '../../../../api/usePredictionRounds/usePredictionEntries';
import { calculateTotalResults } from '../../../../model/calculateTotalResults';
import { PredictionMyResultsCards } from './PredictionMyResultsCards';

export const PredictionMyResults = () => {
  const { data = [], isLoading } = usePredictionEntries();

  const totalResults = calculateTotalResults(data);

  return (
    <div className="flex flex-col items-start gap-6 w-full">
      <Typography variant="h2">My results</Typography>
      <PredictionMyResultsCards data={totalResults} isLoading={isLoading} />
    </div>
  );
};
